import config from './config';

const MAX_MESSAGE_LENGTH = 120;
const PREFIX = '[Jurat Web]';

const normalizeMessage = message => {
  let normalized = message.replace(/\s+/g, ' ').trim();

  if (!normalized) {
    return 'Message';
  }

  normalized = normalized.charAt(0).toUpperCase() + normalized.slice(1);

  if (normalized.length > MAX_MESSAGE_LENGTH) {
    return `${normalized.slice(0, MAX_MESSAGE_LENGTH - 3)}...`;
  }

  return normalized;
};

const formatArgs = (level, args) => {
  const list = Array.from(args);
  const label = `${PREFIX} ${level}:`;

  if (list.length === 0) {
    return [label, 'Message'];
  }

  if (typeof list[0] !== 'string') {
    return [label, ...list];
  }

  return [`${label} ${normalizeMessage(list[0])}`, ...list.slice(1)];
};

const logger = {
  log(...args) {
    if (config.debug) {
      console.log(...formatArgs('INFO', args));
    }
  },

  warn(...args) {
    if (config.debug) {
      console.warn(...formatArgs('WARN', args));
    }
  },

  error(...args) {
    console.error(...formatArgs('ERROR', args));
  }
};

export default logger;
